export const defaultUserModel = {
    teamName: '',
    name: '',
    memberType: 'setter',
    color: ''
}

export const defaultProspectModel = {
    owners:[],
    notes:[],
    utilityBill:null,
    coords: false,
    address:'',
    setter:'',
    closer:'',
    systemInstalled: false,
    appointmentStart:null,
    appointmentSet:false,
}

export const defaultTeamModel = {
    members:[],
    areas:{},
    teamLead:null
}
